import axios from "axios";

let isLoggingOut = false;
let sessionModalHandler = null;

/**
 * REGISTER MODAL HANDLER
 */
export const registerSessionModal = (fn) => {
  sessionModalHandler = fn;
};

/**
 * AXIOS INSTANCE
 */
const api = axios.create({
  baseURL: "/",
});

/**
 * REQUEST INTERCEPTOR
 */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

/**
 * RESPONSE INTERCEPTOR
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      if (!isLoggingOut) {
        isLoggingOut = true;

        // 🔥 buka modal react
        sessionModalHandler?.();
      }
    }

    return Promise.reject(error);
  }
);

/**
 * RESET LOGOUT STATE
 */
export const resetLogoutState = () => {
  isLoggingOut = false;
};

export default api;